export const highlights = {
  CARFAX_ONE_OWNER: {
    title: '1-Owner',
    description: 'Having only 1 previous owner.',
    carfaxLogo: true
  },
  CARFAX_NO_ACCIDENTS: {
    title: 'Accident-free',
    description: 'No damage from accidents reported.',
    carfaxLogo: true
  },
  HIGH_DEMAND: {
    title: 'High Demand',
    description: 'There is high demand for this vehicle in your area. These vehicles usually sell within a few weeks.'
  },
  HIGH_VALUE_OPTIONS: {
    title: 'Loaded with Upgrades',
    description: 'This vehicle is upgraded with high-value features and options.'
  },
  LOW_MILEAGE: {
    title: 'Low Miles',
    description: 'This vehicle has low mileage based on its model year. Vehicles with lower miles generally have a higher value.'
  },
  RARE_FIND: {
    title: 'Rare Vehicle',
    description: 'A rare vehicle in your market area. There are less than 10 of these within 100 miles.'
  },
  GREEN_VEHICLE: {
    title: 'Green Vehicle',
    backgroundColor: '#E3F2DD',
    description: 'Vehicle that produces less harmful impacts to the environment than comparable conventional internal combustion engine vehicles.'
  }
}

export const enums = Object.keys(highlights)
